/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/Strossle/theme';

export const StrossleTheme = theme;
